import { InputPin } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import { useDispatch, useSelector } from 'react-redux'
import { User } from '@lmc/ts-common'
import { FC, useState } from 'react'
import Operations from 'operations'
import { useCreateTemplates } from './hooks'
import { OnboardingLayout } from './OnboardingLayout'
import { OnboardingHeading } from './OnboardingHeading'
import { OnboardingText } from './OnboardingText'
import {
  OnboardingButton,
  OnboardingButtonWrapper,
  OnboardingStepIndicator
} from './OnboardingButton'

type Props = {
  homeId: string
}

export const StepPin: FC<Props> = ({ homeId }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  const user = useSelector(
    (state: { global: { user: User } }) => state.global.user
  )

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const [pin, setPin] = useState<string>()

  const refetchCarer = async () => {
    window.location.reload()
  }

  const { createTemplateData } = useCreateTemplates(homeId, refetchCarer)

  const activatePin = async () => {
    createTemplateData()
    setLoading(true)
    const res = await dispatch(
      Operations.updateListItem({
        listId: 'carers',
        itemId: user?.id,
        successMsg: 'Set the PIN',
        // TODO double check after API update
        json: {
          pin,
          pin_confirm: pin
        }
      })
    )

    if (res) {
      useCreateTemplates(homeId)
    }
    setLoading(false)
  }

  const isValidPin = pin?.length === 4

  return (
    <OnboardingLayout>
      <OnboardingHeading level={1}>
        {t(selfServeConstants.SET_A_PIN)}
      </OnboardingHeading>
      <OnboardingText>{t(selfServeConstants.YOUR_SECURE_CODE)}</OnboardingText>
      <PinWrapper>
        <InputPin onComplete={(e) => setPin(e)} />
      </PinWrapper>
      <OnboardingButtonWrapper>
        <OnboardingButton
          variant="default"
          size="large"
          onClick={activatePin}
          isLoading={loading}
          disabled={!isValidPin}
        >
          {t(selfServeConstants.FINISH)}
        </OnboardingButton>
        <OnboardingStepIndicator>
          {t(selfServeConstants.STEP_X_OF_X, { from: 3, to: 3 })}
        </OnboardingStepIndicator>
      </OnboardingButtonWrapper>
    </OnboardingLayout>
  )
}

const PinWrapper = styled.div`
  z-index: 10;
`
